export const iconFontAwesomeUsersPeopleUserNurse = (
	<i className="fa-solid fa-user-nurse"></i>
);
